import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Medical = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 -3 100 104" : "0 0 90 90"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            {props.BgColor ? <rect x="-2.5" y="-3" width="104" height="104" rx="50" fill={props.BgColor} /> : null}
            <path fillRule="evenodd" clipRule="evenodd" d="M36.0276 26.3996C36.901 20.2935 42.1523 15.5996 48.5 15.5996C54.8476 15.5996 60.0989 20.2935 60.9724 26.3996H68.3C73.2705 26.3996 77.3 30.429 77.3 35.3996V60.5996C77.3 65.5702 73.2705 69.5996 68.3 69.5996H28.7C23.7294 69.5996 19.7 65.5702 19.7 60.5996V35.3996C19.7 30.429 23.7294 26.3996 28.7 26.3996H36.0276ZM39.68 26.3996H57.3199C56.486 22.2916 52.8541 19.1996 48.5 19.1996C44.1458 19.1996 40.5139 22.2916 39.68 26.3996ZM28.7 29.9996C25.7176 29.9996 23.3 32.4173 23.3 35.3996V60.5996C23.3 63.5819 25.7176 65.9996 28.7 65.9996H68.3C71.2823 65.9996 73.7 63.5819 73.7 60.5996V35.3996C73.7 32.4173 71.2823 29.9996 68.3 29.9996H28.7ZM48.5 38.9996C49.4941 38.9996 50.3 39.8055 50.3 40.7996V46.1996H55.7C56.6941 46.1996 57.5 47.0055 57.5 47.9996C57.5 48.9937 56.6941 49.7996 55.7 49.7996H50.3V55.1996C50.3 56.1937 49.4941 56.9996 48.5 56.9996C47.5058 56.9996 46.7 56.1937 46.7 55.1996V49.7996H41.3C40.3058 49.7996 39.5 48.9937 39.5 47.9996C39.5 47.0055 40.3058 46.1996 41.3 46.1996H46.7V40.7996C46.7 39.8055 47.5058 38.9996 48.5 38.9996Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Medical;
